import React from 'react';
import { NavLink } from 'react-router-dom';
import { FooterMenuItem } from './types';

type FooterMenuProps = {
    items: Array<FooterMenuItem>,
    visibility: 'always' | 'mobile',
    className: string,
};

const FooterMenu: React.FC<FooterMenuProps> = ({ items, className }: FooterMenuProps) => (
    <div className={className}>
        {items.map(item => (
            <NavLink
                to={item.link}
                key={item.caption}
                exact={item.exact}
                activeStyle={item.activeColor ? { color: item.activeColor } : {}}
            >
                {item.iconActiveUrl ? (<img src={item.iconActiveUrl} alt={item.caption} className="icon-active" />) : null}
                <img src={item.iconUrl} alt={item.caption} />
                <span>{item.caption}</span>
            </NavLink>
        ))}
    </div>
);

export default FooterMenu;
